export class ItemPart {
	checked: boolean;
	id: string;

	parentItemInfo: any;

	name: string;

	startTime: number;
	finishTime: number;


	constructor(startTime, finishTime, name) {
		this.id = `f${(~~(Math.random() * 1e8)).toString(16)}`;

		this.name = name;

		this.startTime = startTime;
		this.finishTime = finishTime;

		this.parentItemInfo = null;
	}

	static copyFromParsed(itemToCopy): ItemPart {
		let newItemPart = new ItemPart(itemToCopy.startTime, itemToCopy.finishTime, itemToCopy.name);

		newItemPart.id = itemToCopy.id;
		newItemPart.checked = itemToCopy.checked;
		newItemPart.name = itemToCopy.name;
		newItemPart.startTime = itemToCopy.startTime;
		newItemPart.finishTime = itemToCopy.finishTime;

		newItemPart.parentItemInfo = itemToCopy.parentItemInfo;

		return newItemPart;
	}
}
